import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { environment } from '@env';

export const devGuard: CanActivateFn = () => {
  if (environment.isDev) return true;
  const router = inject(Router);
  return router.createUrlTree(['/']);
};
